import { format, set } from "date-fns";

/** Combine a calendar day and an "HH:mm" time into a local Date instant. */
function combineDateAndTimeAsDate(date: Date, time: string): Date {
  const [h, m] = time.split(":").map(Number);
  return set(date, { hours: h, minutes: m, seconds: 0, milliseconds: 0 });
}

/** Combine a calendar day and an "HH:mm" time into a UTC ISO instant. */
export function combineDateAndTime(date: Date, time: string): string {
  return combineDateAndTimeAsDate(date, time).toISOString();
}

/**
 * Whether the edit form's combined range runs backwards (end strictly before
 * start — equal is allowed, zero-length events exist). The pickers shift the
 * end alongside the start, so this should be unreachable, but a seeding or
 * state edge that slips one through must not reach the server, which rejects
 * it with a 400 the form has no field-level place to surface (BIG-7535).
 * All-day events compare inclusive end days; timed events compare the
 * combined instants numerically.
 */
export function isTimeRangeInvalid(args: {
  isAllDay: boolean;
  startDate: Date;
  startTime: string;
  endDate: Date;
  endTime: string;
}): boolean {
  return args.isAllDay
    ? format(args.endDate, "yyyy-MM-dd") < format(args.startDate, "yyyy-MM-dd")
    : combineDateAndTimeAsDate(args.endDate, args.endTime).getTime() <
        combineDateAndTimeAsDate(args.startDate, args.startTime).getTime();
}
